<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/fan' }">
        <app-i18n code="entities.fan.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.fan.edit.title" v-if="isEditing"></app-i18n>
        <app-i18n code="entities.fan.new.title" v-if="!isEditing"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.fan.edit.title" v-if="isEditing"></app-i18n>
        <app-i18n code="entities.fan.new.title" v-if="!isEditing"></app-i18n>
      </h1>

      <div class="app-page-spinner" v-if="findLoading" v-loading="findLoading"></div>

      <el-form
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        :model="model"
        :rules="rules"
        @submit.native.prevent="doSubmit"
        class="form"
        ref="form"
        v-if="model"
      >
        <el-form-item :label="fields.id.label" :prop="fields.id.name" v-if="isEditing">
          <el-col :lg="11" :md="16" :sm="24">
            <el-input :disabled="true" v-model="model[fields.id.name]"/>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.name.label"
          :prop="fields.name.name"
          :required="fields.name.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input v-model="model[fields.name.name]" ref="focus" />
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.lastName.label"
          :prop="fields.lastName.name"
          :required="fields.lastName.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input v-model="model[fields.lastName.name]" />
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.picture.label"
          :prop="fields.picture.name"
          :required="fields.picture.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <app-image-upload
              :max="fields.picture.max"
              :path="fields.picture.path"
              :schema="fields.picture.fileSchema"
              v-model="model[fields.picture.name]"
              :placeholder="i18n('common.uploadFile')"
            ></app-image-upload>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.uid.label"
          :prop="fields.uid.name"
          :required="fields.uid.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input v-model="model[fields.uid.name]" />
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.teams.label"
          :prop="fields.teams.name"
          :required="fields.teams.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <app-autocomplete-many-input
              :fetchFn="fields.teams.fetchFn"
              v-model="model[fields.teams.name]"
            ></app-autocomplete-many-input>
          </el-col>
        </el-form-item>

        <el-form-item>
          <div class="form-buttons">
            <el-button
              :disabled="saveLoading"
              @click="doSubmit"
              icon="el-icon-fa-floppy-o"
              type="primary"
            >
              <app-i18n code="common.save"></app-i18n>
            </el-button>

            <!-- <el-button :disabled="saveLoading" @click="doReset" icon="el-icon-fa-undo">
              <app-i18n code="common.reset"></app-i18n>
            </el-button> -->
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { FormSchema } from '@shared/form/form-schema';
import { FanModel } from '@modules/fan/fan-model';

const { fields } = FanModel;
const formSchema = new FormSchema([
  fields.id,
  fields.name,
  fields.lastName,
  fields.picture,
  fields.uid,
  fields.teams,
]);

export default {
  name: 'app-fan-form-page',

  props: ['id'],

  data() {
    return {
      rules: formSchema.rules(),
      model: null,
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'fan/form/record',
      findLoading: 'fan/form/findLoading',
      saveLoading: 'fan/form/saveLoading',
    }),

    isEditing() {
      return !!this.id;
    },

    fields() {
      return fields;
    },
  },

  async created() {
    if (this.isEditing) {
      await this.doFind(this.id);
    } else {
      await this.doNew();
    }

    this.model = formSchema.initialValues(this.record);
  },

  methods: {
    ...mapActions({
      doFind: 'fan/form/doFind',
      doNew: 'fan/form/doNew',
      doUpdate: 'fan/form/doUpdate',
      doCreate: 'fan/form/doCreate',
    }),

    doReset() {
      this.model = formSchema.initialValues(this.record);
    },

    async doSubmit() {
      try {
        await this.$refs.form.validate();
      } catch (error) {
        return;
      }

      const { id, ...values } = formSchema.cast(this.model);

      if (this.isEditing) {
        return this.doUpdate({
          id,
          values,
        });
      } else {
        return this.doCreate(values);
      }
    },
  },
};
</script>

<style>
</style>
